import React from 'react';

import * as ContextMenu from 'components/ContextMenu';
import NoteConstants from 'notebook/notes/NoteConstants';
import * as Modals from 'util/Modals';

const {MAX_NAME_LENGTH} = NoteConstants;
export interface NoteLinkedEmbeddingMenuProps {
  children?: React.ReactNode;
  name: string;
  onRename?: (newName: string) => void;
}

export default function NoteLinkedEmbeddingMenu({
  children,
  name,
  onRename,
}: NoteLinkedEmbeddingMenuProps): JSX.Element {
  const validate = (newName: string): boolean => newName.length > 0 && newName.length <= MAX_NAME_LENGTH;
  const click = (): void => {
    Modals.prompt('Rename', name, validate).done(onRename);
  };
  const handleContextMenu = (e: React.MouseEvent): void => {
    ContextMenu.view.open(e.nativeEvent, [{name: 'Rename...', click}]);
  };

  return <span onContextMenu={onRename ? handleContextMenu : undefined}>{children}</span>;
}
